import { useTranslation } from "react-i18next";
import { Form, Spin } from "antd";
import { FC } from "react";
import CustomCard from "../../../../custom-card/CustomCard";
import "./administrative-unit-detail.scss";
interface AdministrativeUnitDetailProps {
  administrativeUnitDetail: any;
  loadingDetail: boolean;
  textRendered?: string;
  tab?: string,
}

const AdministrativeUnitDetail: FC<AdministrativeUnitDetailProps> = ({
  administrativeUnitDetail,
  loadingDetail,
  textRendered,
  tab,
}) => {
  const { t } = useTranslation();
  return (
    <section className="wrapper-settings category-management-detail" style={{height: "auto"}}>
      <div className="setting-position wrapper-inside">
        <CustomCard className="header-card" title={tab === "1" ? t("Thông tin đơn vị cấp Tỉnh", "Thông tin đơn vị cấp Tỉnh") : tab === "2" ? t("Thông tin đơn vị cấp Huyện", "Thông tin đơn vị cấp Huyện") : t("Thông tin đơn vị cấp Xã", "Thông tin đơn vị cấp Xã")}>
          {loadingDetail ? (
            <div className="statistic-course-content statistic-course-loading">
              <Spin size="large" />
            </div>
          ) : (
            <section>
              <Form.Item className="setting-item" name="code" label={t("Mã", "Mã")}>
                <p className="position-content">{administrativeUnitDetail?.code}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="codeName" label={t("Tên mã", "Tên mã")}>
                <p className="position-content">{administrativeUnitDetail?.codeName}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="name" label={t("Tên", "Tên")}>
                <p className="position-content">{administrativeUnitDetail?.name}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="fullName" label={t("Tên đầy đủ", "Tên đầy đủ")}>
                <p className="position-content">{administrativeUnitDetail?.fullName}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="nameEn" label={t("Tên tiếng Anh", "Tên tiếng Anh")}>
                <p className="position-content">{administrativeUnitDetail?.nameEn}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="fullNameEn" label={t("Tên tiếng Anh đầy đủ", "Tên tiếng Anh đầy đủ")}>
                <p className="position-content">{administrativeUnitDetail?.fullNameEn}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="createdDate" label={t("Ngày tạo", "Ngày tạo")}>
                <p className="position-content">{administrativeUnitDetail?.createdDate}</p>
              </Form.Item>
              {
                tab !== "1" ? 
                <Form.Item className="setting-item" name="provinceName" label={t("Đơn vị cấp Tỉnh", "Đơn vị cấp Tỉnh")}>
                  <p className="position-content">{administrativeUnitDetail?.provinceName}</p>
                </Form.Item>
                : null
              }
              {
                tab === "3" ? 
                <Form.Item className="setting-item" name="districtName" label={t("Đơn vị cấp Huyện", "Đơn vị cấp Huyện")}>
                  <p className="position-content">{administrativeUnitDetail?.districtName}</p>
                </Form.Item>
                : null
              }
            </section>
          )}
        </CustomCard>
      </div>
    </section>
  );
};

export default AdministrativeUnitDetail;
